<template>
	<div class="p-4 mb-4 rounded-lg bg-blue-50">
		<div class="flex items-center gap-3">
			<Icon :icon="['far', 'info-circle']" class="text-blue-900" />
			<div>
				<p class="mb-0 text-sm text-blue-900">
					<slot name="default" />
				</p>
			</div>
			<slot name="additional-content" />
		</div>
	</div>
</template>

<script>
import Icon from '~/components/ui/common/Icon'

export default {
	name: 'InformationBanner',
	components: {
		Icon
	}
}
</script>
